import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {interval, Subject} from 'rxjs';
import {COUNTDOWN_GET_STATUS_MILLISECONDS} from '../../../../../environments/environment.const';
import {ItemService} from '../../../../services/item.service';
import {TranslateService} from '../../services/translate.service';
import {NonElectronicCountdownService} from './non-electronic-countdown.service';
import {HttpErrorResponse} from '@angular/common/http';
import {INonElectronicCountdownSyncData} from './non-electronic-countdown.types';
import {DateUtil} from '../../utils/date.util';

@Component({
    selector: 'app-non-electronic-countdown',
    templateUrl: './non-electronic-countdown.component.html',
    styleUrls: ['./non-electronic-countdown.component.styl']
})
export class NonElectronicCountdownComponent implements OnInit, OnDestroy {
    @Output() isTerminated = new EventEmitter<boolean>();
    refresher: Subject<void> = new Subject();
    seconds: number;
    minutes: number;
    hours: number;
    days: number;
    message: string;
    data: INonElectronicCountdownSyncData;
    isLoadingData: boolean;
    tenderRevisionId: number;
    counter = interval(COUNTDOWN_GET_STATUS_MILLISECONDS);
    $syncSubscription = undefined;
    $counterSubscription = undefined;
    isTimeOver = false;
    procurementTypeSlug;
    @Input() selectionMethodSlug: string;

    constructor(private nonElectronicCountdownService: NonElectronicCountdownService,
                private itemService: ItemService,
                public translateService: TranslateService) {
        this.tenderRevisionId = this.itemService.info.getValue().data.tender_revision_id;
        this.refresher.subscribe(() => {
            this.$syncSubscription.unsubscribe();
            this.ngOnInit();
        });
    }

    ngOnInit() {
        this.tenderRevisionId = this.itemService.info.getValue().data.tender_revision_id;
        this.procurementTypeSlug = this.itemService.info.getValue().data.procurement_type_slug;
        this.resetSubscriptions();
        this.load(this.tenderRevisionId);
        this.$syncSubscription = this.counter.subscribe(() => {
            this.load(this.tenderRevisionId);
        });
    }

    load(tenderRevisionId) {
        this.isLoadingData = true;
        this.nonElectronicCountdownService.getData(tenderRevisionId, this.procurementTypeSlug, this.selectionMethodSlug)
            .subscribe((result: INonElectronicCountdownSyncData) => {
                if (result) {
                    this.startTimer(result);
                }
            }, (error: HttpErrorResponse) => {
                console.error(error);
                this.isLoadingData = false;
            });
    }

    private startTimer(result: INonElectronicCountdownSyncData) {
        if (this.$counterSubscription !== undefined) {
            this.$counterSubscription.unsubscribe();
        }
        this.$counterSubscription = interval(1000).subscribe((d) => {
            if (this.isLoadingData) {
                this.isLoadingData = false;
            }
            const t = this.getTimeRemaining(result.end_date);
            this.data = result;
            if (t.total <= 0) {
                this.$counterSubscription.unsubscribe();
                this.isTerminated.emit(true);
                this.isTimeOver = true;
            } else {
                this.isTimeOver = false;
            }
            this.seconds = t.seconds;
            this.minutes = t.minutes;
            this.hours = t.hours;
            this.days = t.days;
        });
    }

    getTimeRemaining(endDate) {
        const totalRemaining = Date.parse(endDate) - Date.parse((DateUtil.convert(new Date())).toString());
        if (totalRemaining <= 0) {
            return {
                total: totalRemaining,
                seconds: 0,
                minutes: 0,
                hours: 0,
                days: 0
            };
        }
        return {
            total: totalRemaining,
            seconds: Math.floor((totalRemaining / 1000) % 60),
            minutes: Math.floor((totalRemaining / (1000 * 60)) % 60),
            hours: Math.floor((totalRemaining / (1000 * 60 * 60)) % 24),
            days: Math.floor(totalRemaining / (1000 * 60 * 60 * 24))
        };
    }

    private resetSubscriptions() {
        if (this.$syncSubscription !== undefined) {
            this.$syncSubscription.unsubscribe();
        }
        if (this.$counterSubscription !== undefined) {
            this.$counterSubscription.unsubscribe();
        }
    }

    ngOnDestroy() {
        this.resetSubscriptions();
    }
}
